import React from 'react'
import styled from 'styled-components'

interface Props {
  height?: number,
  width?: number,
  size?: number
}

const Svg = styled.svg`
  height: ${(props: Props) => props.size || props.height}px;
  width: ${(props: Props) => props.size || props.width}px;
`

export default (props: Props) => <Svg {...props} viewBox='0 0 120 120'>
  <defs>
    <filter id='Path_122' x='3.799' y='6' width='113.103' height='117.103' filterUnits='userSpaceOnUse'>
      <feOffset dy='4' />
      <feGaussianBlur result='blur' />
      <feFlood floodOpacity='0.4' />
      <feComposite operator='in' in2='blur' />
      <feComposite in='SourceGraphic' />
    </filter>
  </defs>
  <rect id='Frame' width='120' height='120' transform='translate(0 1)' fill='none' />
  <g transform='matrix(1, 0, 0, 1, 0, 0)' filter='url(#Path_122)'>
    <path id='Path_122-2' data-name='Path 122' d='M78.767,50.339a5.231,5.231,0,0,0,1.4-3.834l-.244-10.863A5.457,5.457,0,0,0,78.2,31.588a5.694,5.694,0,0,0-3.9-1.575l-23.362-.524-.6-23.44a5.319,5.319,0,0,0-1.575-3.9A5.206,5.206,0,0,0,44.78.5L33.916.253a4.885,4.885,0,0,0-3.836,1.4,4.944,4.944,0,0,0-1.473,3.908L29.059,29l-23.507-.38a5.056,5.056,0,0,0-3.836,1.4A4.939,4.939,0,0,0,.242,33.927L.558,44.718A5.019,5.019,0,0,0,2.209,48.7a4.6,4.6,0,0,0,3.9,1.575l23.438.6.527,23.51a4.943,4.943,0,0,0,1.575,3.9C32.87,79.5,34,80.2,35.63,79.935l10.789.316a5.715,5.715,0,0,0,3.908-1.474,5.223,5.223,0,0,0,1.4-3.836l-.305-23.579,23.51.528A5.156,5.156,0,0,0,78.767,50.339Z' transform='translate(60.37 5.66) rotate(45)' fill='#afafaf' />
  </g>
  <path id='Path_1217' data-name='Path 1217' d='M78.767,50.339a5.231,5.231,0,0,0,1.4-3.834l-.244-10.863A5.457,5.457,0,0,0,78.2,31.588a5.693,5.693,0,0,0-3.9-1.575l-23.362-.524-.6-23.44a5.319,5.319,0,0,0-1.575-3.9A5.206,5.206,0,0,0,44.78.5L33.916.253a4.884,4.884,0,0,0-3.836,1.4,4.943,4.943,0,0,0-1.473,3.908L29.059,29l-23.507-.38a5.054,5.054,0,0,0-3.836,1.4A4.94,4.94,0,0,0,.242,33.927L.558,44.718A5.021,5.021,0,0,0,2.209,48.7a4.6,4.6,0,0,0,3.9,1.575l23.438.6.527,23.51a4.943,4.943,0,0,0,1.575,3.9C32.87,79.5,34,80.2,35.631,79.935l10.788.316a5.715,5.715,0,0,0,3.908-1.474,5.224,5.224,0,0,0,1.4-3.836l-.306-23.579,23.51.528A5.157,5.157,0,0,0,78.767,50.339Z' transform='translate(60.375 -0.339) rotate(45)' fill='#fff' />
</Svg>
